import { render, staticRenderFns } from "./updatePromotions.vue?vue&type=template&id=5de455de&"
import script from "./updatePromotions.vue?vue&type=script&lang=js&"
export * from "./updatePromotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports